import React from 'react';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { Header } from '../../Output.styles';
import { getPersonaIcon } from '../../../utils/getPersonaIcon';

export const IndividualHeader = ({
  primaryRespondentHighlightedCategory,
  primaryRespondentScore,
  primaryRespondentHeader,
}) => {
  const isMobile = useIsMobile();

  return (
    <Header>
      <Icon
        className={getPersonaIcon({
          persona: primaryRespondentHighlightedCategory,
          score: primaryRespondentScore,
        })}
        fontSize="xxl"
        color="neutral.700"
        mb="16"
        aria-hidden="true"
      />

      <Text
        as="h1"
        fontSize={isMobile ? 'h2' : 'xl'}
        fontWeight={600}
        mb="24"
        css={`
          line-height: ${isMobile ? '40px' : '56px'};
        `}
      >
        {primaryRespondentHeader}
      </Text>
    </Header>
  );
};
